import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import Link from 'next/link';

import { theme } from '_constants/theme';
import { ICONS_ALIASES } from '_constants/icons';
import { ROUTES } from '_constants/routes';

import Accordion from '_components/atomic/Accordion';
import Icon from '_components/atomic/Icon';
import Text from '_components/atomic/layouts/Card/Text';

const StyledOuterContainer = styled.div`
  max-width: ${theme.spaces.large23X * 10 + 10 + 8}px;
  width: 100%;
  padding: ${theme.spaces.small2X}px;
`;

const StyledInnerContainer = styled.div`
  padding-top: ${theme.spaces.large18X}px;
  padding-bottom: ${theme.spaces.large18X}px;

  .package-faq-item {
    padding-bottom: ${theme.spaces.large2X}px;
    margin-bottom: ${theme.spaces.large2X}px;
    border-bottom: 1px solid ${theme.colors.gray[200]};
  }

  @media ${theme.devices.tablet} {
    padding-top: ${theme.spaces.large4X}px;
    padding-bottom: ${theme.spaces.large4X}px;
    padding-left: ${theme.spaces.smallX}px;
    padding-right: ${theme.spaces.smallX}px;
  }
`;

const StyledContentBox = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.large14X}px;

  > * {
    &:first-child {
      min-width: 30px;
    }
  }

  @media ${theme.devices.tablet} {
    > * {
      &:first-child {
        min-width: 24px;
      }
    }
  }
`;

const PackageFAQSection = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Text
          size={
            isMobile ? theme.fontSizes.large2X : theme.fontSizes.large10X - 2
          }
          weight={600}
          centered={isMobile}
          bottomSpace={isMobile ? theme.spaces.large6X : theme.spaces.large10X}
        >
          Frequently Asked Questions
        </Text>
        <Accordion
          openIcon={
            <Icon
              alias={ICONS_ALIASES.chevronUp}
              color={theme.colors.gray[800]}
            />
          }
          closeIcon={
            <Icon
              alias={ICONS_ALIASES.chevronDown}
              color={theme.colors.gray[800]}
            />
          }
          items={[
            {
              openByDefault: false,
              className: 'package-faq-item',
              title: (
                <StyledContentBox>
                  <Text
                    size={
                      isMobile
                        ? theme.fontSizes.regular
                        : theme.fontSizes.large2X
                    }
                    weight={500}
                    color={theme.colors.indigo[600]}
                  >
                    01
                  </Text>
                  <Text
                    size={
                      isMobile
                        ? theme.fontSizes.regular
                        : theme.fontSizes.large2X
                    }
                    weight={500}
                  >
                    What will my phone number be used for?
                  </Text>
                </StyledContentBox>
              ),
              body: (
                <StyledContentBox>
                  <div />
                  <Text
                    size={
                      isMobile ? theme.fontSizes.regular : theme.fontSizes.large
                    }
                    weight={400}
                    lineHeightRatio={1.5}
                    topSpace={theme.spaces.large2X}
                  >
                    The prices referenced in all of our formation packages are a
                    one-time fee unlike some of our more unsavory competitors
                    our goal is not to trap our clients into a perpetual
                    never-ending subscription but rather to provide fair upfront
                    transparent pricing. While other companies attempt to build
                    their businesses on the idea that the consumer is an idiot
                    our business has been built over decades on the premise of
                    always providing value-driven affordable solutions for
                    entrepreneurs.
                  </Text>
                </StyledContentBox>
              ),
            },
            {
              openByDefault: false,
              className: 'package-faq-item',
              title: (
                <StyledContentBox>
                  <Text
                    size={
                      isMobile
                        ? theme.fontSizes.regular
                        : theme.fontSizes.large2X
                    }
                    weight={500}
                    color={theme.colors.indigo[600]}
                  >
                    02
                  </Text>
                  <Text
                    size={
                      isMobile
                        ? theme.fontSizes.regular
                        : theme.fontSizes.large2X
                    }
                    weight={500}
                  >
                    Do I need to pay extra for compliance notifications?
                  </Text>
                </StyledContentBox>
              ),
              body: (
                <StyledContentBox>
                  <div />
                  <Text
                    size={
                      isMobile ? theme.fontSizes.regular : theme.fontSizes.large
                    }
                    weight={400}
                    lineHeightRatio={1.5}
                    topSpace={theme.spaces.large2X}
                  >
                    Never, every single one of our formation packages includes
                    lifetime compliance notifications via email and text alerts
                    so you will always know when any federal or state compliance
                    obligations are due. Upon being alerted you will always have
                    the option to file the required documents yourself or have
                    them filed by one of our incorporation specialists.
                  </Text>
                </StyledContentBox>
              ),
            },
            {
              openByDefault: false,
              className: 'package-faq-item',
              title: (
                <StyledContentBox>
                  <Text
                    size={
                      isMobile
                        ? theme.fontSizes.regular
                        : theme.fontSizes.large2X
                    }
                    weight={500}
                    color={theme.colors.indigo[600]}
                  >
                    03
                  </Text>
                  <Text
                    size={
                      isMobile
                        ? theme.fontSizes.regular
                        : theme.fontSizes.large2X
                    }
                    weight={500}
                  >
                    Will I have the option to act as my own registered agent?
                  </Text>
                </StyledContentBox>
              ),
              body: (
                <StyledContentBox>
                  <div />
                  <Text
                    size={
                      isMobile ? theme.fontSizes.regular : theme.fontSizes.large
                    }
                    weight={400}
                    lineHeightRatio={1.5}
                    topSpace={theme.spaces.large2X}
                  >
                    Yes, you can act as your own registered agent. However, we
                    offer Registered Agent Service free of charge for the first
                    year.
                  </Text>
                </StyledContentBox>
              ),
            },
            {
              openByDefault: false,
              className: 'package-faq-item',
              title: (
                <StyledContentBox>
                  <Text
                    size={
                      isMobile
                        ? theme.fontSizes.regular
                        : theme.fontSizes.large2X
                    }
                    weight={500}
                    color={theme.colors.indigo[600]}
                  >
                    04
                  </Text>
                  <Text
                    size={
                      isMobile
                        ? theme.fontSizes.regular
                        : theme.fontSizes.large2X
                    }
                    weight={500}
                  >
                    Will I need to sign anything?
                  </Text>
                </StyledContentBox>
              ),
              body: (
                <StyledContentBox>
                  <div />
                  <Text
                    size={
                      isMobile ? theme.fontSizes.regular : theme.fontSizes.large
                    }
                    weight={400}
                    lineHeightRatio={1.5}
                    topSpace={theme.spaces.large2X}
                  >
                    No, documents requiring signatures will be signed by our
                    staff. We will sign as the incorporator for corporations,
                    and for LLCs we will sign as the organizer.
                  </Text>
                </StyledContentBox>
              ),
            },
          ]}
        />
        <Text
          size={theme.fontSizes.regular}
          weight={400}
          centered
          topSpace={theme.spaces.large10X}
        >
          Didn’t find the answer here? Don’t hesitate to&nbsp;
          <Link href={ROUTES.contactUs}>Contact Us</Link> and we’ll be more than
          happy to help you!
        </Text>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default PackageFAQSection;
